// A preview build served against an API with no PostHog can name the flags
// it wants on, comma-separated, at dev time. Production builds set none, so
// every flag keeps its PostHog answer and its fallback.
const previewFlags = new Set(
  (import.meta.env.VITE_PREVIEW_FLAGS ?? "")
    .split(",")
    .map((key: string) => key.trim())
    .filter(Boolean),
);

const disabledPreviewFlags = new Set(
  (import.meta.env.VITE_DISABLED_PREVIEW_FLAGS ?? "")
    .split(",")
    .map((key: string) => key.trim())
    .filter(Boolean),
);

// Preview navigation is a presentation mode, not a PostHog feature flag. It
// keeps the production information architecture visible while experimental
// behavior remains disabled independently.
export const productionNavigationPreviewEnabled =
  import.meta.env.VITE_HIDE_NAV_STATUS_LABELS === "true";

// Lango can exercise the production demo-mode path without PostHog.
export const demoEstatePreviewEnabled =
  import.meta.env.VITE_DEMO_ESTATE_DATA === "true";

export function previewFlagEnabled(key: string | undefined): boolean {
  return key !== undefined && previewFlags.has(key);
}

export function previewFlagDisabled(key: string | undefined): boolean {
  return (
    key !== undefined &&
    (disabledPreviewFlags.has("*") || disabledPreviewFlags.has(key))
  );
}
